//eventually refactor /editor/[slug].js to use this component

import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import LinkIcon from '../../Icons/link';
import TwitterImage from '../../TwitterImage';
var twitter = require('twitter-text');

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { formatThread } from '../../../utils/publishing/twitter';
import { client } from '../../../utils/http';

export default function ThreadPreview({
  twitterEditorText,
  userID,
  inEditor = false,
  activeTypeshareID,
  twitterHandle,
  twitterName,
  twitterPhoto,
  passRawTweetArray,
  passImageIDArray,
  passImageDataArray,
  passTwitterText,
  passThreadMeta,
  twitterSecret,
  twitterToken,
}) {
  //twitterEditorText is editorContent.val().content.twitterText

  const [twitterText, setTwitterText] = useState('');

  const [tweetArray, setTweetArray] = useState([]);
  const [tweetArrayLength, setTweetArrayLength] = useState(0);
  const [rawTweetArray, setRawTweetArray] = useState([]);

  const [quoteTweetArray, setQuoteTweetArray] = useState([]);
  const [cachedTweets, setCachedTweets] = useState([]);

  const [hasImages, setHasImages] = useState(false);
  const [imageIDArray, setImageIDArray] = useState([]);
  const [imageDataArray, setImageDataArray] = useState([]);

  const [cachedPreviews, setCachedPreviews] = useState([]);
  const [quoteIndexes, setQuoteIndexes] = useState([]);
  const [linkPreviews, setLinkPreviews] = useState([]);
  const [previewIndexes, setPreviewIndexes] = useState([]);

  const [displayName, setDisplayName] = useState('');
  const [photoURL, setPhotoURL] = useState('');

  const [activeTweet, setActiveTweet] = useState(null);

  const [tweetLengths, setTweetLengths] = useState([]);

  useEffect(() => {
    //update threadMeta
    passThreadMeta({
      newImageArray: imageIDArray ? imageIDArray : null,
      linkPreviews: linkPreviews ? linkPreviews : null,
      quotes: {
        cachedTweets: cachedTweets ? cachedTweets : null,
        quoteTweetArray: quoteTweetArray ? quoteTweetArray : null,
      },
      tweetArray: rawTweetArray,
    });
  }, [
    imageIDArray,
    linkPreviews,
    cachedTweets,
    quoteTweetArray,
    rawTweetArray,
  ]);

  useEffect(() => {
    passRawTweetArray && passRawTweetArray(rawTweetArray);
  }, [rawTweetArray]);

  useEffect(() => {
    passImageIDArray && passImageIDArray(imageIDArray);
  }, [imageIDArray]);

  useEffect(() => {
    passImageDataArray && passImageDataArray(imageDataArray);
  }, [imageDataArray]);

  useEffect(() => {
    passTwitterText && passTwitterText(twitterText);
  }, [twitterText]);

  useEffect(() => {
    if (twitterEditorText && twitterSecret && twitterToken) {
      getInitialTwitterText(twitterEditorText);
    }
  }, [twitterEditorText, twitterSecret, twitterToken]);

  const problemToast = (text) =>
    toast.error(text, {
      id: 'error',
      /* icon: '🪄', */
      style: {
        borderRadius: '100px',
        background: '#0F172A',
        color: '#fff',
      },
    });

  const convertToPlainText = (html) => {
    var el = document.createElement('div');
    el.innerHTML = html;
    var text = el.textContent;

    return text;
  };

  const getInitialTwitterText = (text) => {
    //check if text is not an object
    try {
      if (text) {
        if (typeof text !== 'object') {
          var hasIMGS = false;

          if (text.includes('<img')) {
            hasIMGS = true;
          }
          setHasImages(hasIMGS);

          var convertedText = text.replace(
            /<\/(h2|h3|p|blockquote|img|code)><(h2|h3|p|blockquote|img|code)>/g,
            '\n',
          );

          var convertedText = convertedText.replace(/<ul>/g, '\n');
          var convertedText = convertedText.replace(/<ol>/g, '\n');
          var convertedText = convertedText.replace(/<\/li>/g, '\n');
          convertedText = convertedText.replace(/(<li>)/g, '• ');
          convertedText = convertedText.replace(/(<br>)/g, '\n');
          convertedText = convertedText.replace(
            /(<a target="_blank" rel="noopener noreferrer nofollow" href=")(.*)(">)(.*)(<\/a>)/g,
            '$2',
          );

          var twitterPlainText = convertedText.replace(
            /<img id="(.*?)" src="(.*?)">/g,
            '\n{{img: $1 }}\n',
          );

          twitterPlainText = twitterPlainText.replace(/<[^>]*>?/gm, '');
          twitterPlainText = twitterPlainText.trim();
          var tpText = convertToPlainText(twitterPlainText);
          setTwitterText(tpText);

          const splitted = tpText.split('\n\n\n');

          var tmpArr = [];
          splitted.forEach((str) => {
            var plain = convertToPlainText(str);
            tmpArr.push(plain);
          });
          let trimedArr = tmpArr.map((str) => str.trim());
          handleHashtag(trimedArr);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  async function handleHashtag(splitted) {
    if (splitted !== null) {
      let trimedArr2 = splitted.map((str) => str.trim());
      var array = splitted;

      var rawArray = trimedArr2;
      var toastGif = false;

      array.forEach((tweet, i) => {
        var rawTweet = tweet;

        var imageElementID = `tweet-image-${i}`;
        var b = `tweet-paragraph-${i}`;

        if (tweet.includes('{{img:') || tweet.includes('{{gif:')) {
          //find everyting between {{img: and }} or {{gif: and }}
          var regex = /{{(img|gif):(.*?)}}/g;
          var reg = /{{img:([^}}]*)/g;
          var imgReg = /{{img:.*?}}|{{gif:.*?}}/g;
          var result;
          var results2 = [];
          var resultsWithoutBrokenImages = [];
          var numOfImages = 0;
          var numGifs = 0;

          while ((result = regex.exec(tweet)) !== null) {
            //trim spaces
            var trimmed = result[2].trim();

            results2.push(trimmed);

            if (trimmed.length === 6 || trimmed.length === 20) {
              if (tweet.includes(`{{gif:${result[2]}}}`)) {
                numGifs += 1;

                if (resultsWithoutBrokenImages.length < 1) {
                  resultsWithoutBrokenImages.push(trimmed);
                }
              }

              if (tweet.includes(`{{img:${result[2]}}}`)) {
                //only push the first 4 results
                if (numGifs < 1) {
                  if (resultsWithoutBrokenImages.length < 4) {
                    resultsWithoutBrokenImages.push(trimmed);
                  }
                }
                numOfImages++;
              }
            }
          }

          if (numOfImages > 4) {
            problemToast('Twitter only allows 4 images per tweet');
          }

          if (numOfImages > 0 && numGifs > 0) {
            problemToast('Twitter only allows 1 gif or 4 photos per tweet');
          } else if (numGifs > 1) {
            problemToast('Twitter only allows 1 gif per tweet');
          }

          resultsWithoutBrokenImages.forEach((imageID) => {
            if (resultsWithoutBrokenImages.length > 1) {
              var hasGif = imageID.includes('.gif');
              if (hasGif) {
                problemToast('Twitter only allows 1 gif or 4 photos per tweet');
              }
            }
            //check if imageid ecists in resultswithoutbrokenimages
            if (resultsWithoutBrokenImages.includes(imageID)) {
            } /* else {
                            removeImage2(imageID)
                        } */

            //check if image exists in imagedataarray
            if (imageDataArray[imageID] === undefined) {
              //if image doesn't exist, get image data from db
              if (
                (imageID.length === 6 || imageID.length === 20) &&
                (tweet.includes(`{{img: ${imageID} }}`) ||
                  tweet.includes(`{{gif: ${imageID} }}`))
              ) {
                getImageFromDB(imageID, i);
              } else {
                //remove imageID from results2
              }

              setImageIDArray((prevState) => ({
                ...prevState,
                [i]: resultsWithoutBrokenImages,
              }));
            } else {
              //add image name to image id array with an i

              setImageIDArray((prevState) => ({
                ...prevState,
                [i]: resultsWithoutBrokenImages,
              }));
            }

            //remove new lines if any exist right afrer the image and if they dont - still remove the image tag
            tweet = tweet.replace(`{{img: ${imageID} }}\n`, '');
            tweet = tweet.replace(`{{img: ${imageID} }}`, '');

            rawTweet = rawTweet.replace(`{{img: ${imageID} }}\n`, '');
            rawTweet = rawTweet.replace(`{{img: ${imageID} }}`, '');

            tweet = tweet.replace(`{{gif: ${imageID} }}\n`, '');
            tweet = tweet.replace(`{{gif: ${imageID} }}`, '');

            rawTweet = rawTweet.replace(`{{gif: ${imageID} }}\n`, '');
            rawTweet = rawTweet.replace(`{{gif: ${imageID} }}`, '');
          });
        } else {
          //find

          setImageIDArray((prevState) => ({
            ...prevState,
            [i]: null,
          }));
        }

        var checkAutoLink = twitter.default.autoLink(tweet);

        //is a link show preview
        if (
          tweet.includes('https://twitter.com/') &&
          tweet.includes('/status/')
        ) {
          var tweetID = tweet.split('/status/')[1];
          var userHanlde = tweet
            .split('/status/')[0]
            .split('https://twitter.com/')[1];
          tweetID = tweetID.split('/')[0];
          tweetID = tweetID.split(' ')[0];
          tweetID = tweetID.split('\n')[0];

          if (quoteTweetArray.length > 0) {
            //check if id exists in cache
            var exists = cachedTweets[tweetID] !== undefined;

            if (exists === false) {
              //get tweet
              if (tweetID.length === 19 && twitterSecret && twitterToken) {
                getQuoteTweet(tweetID, i);

                //we dont want to remove the link from the raw tweet cause we need to send it to twitter

                tweet = tweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}\n`,
                  '',
                );
                rawTweet = rawTweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}\n`,
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                );

                tweet = tweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                  '',
                );
                rawTweet = rawTweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                );
              } else {
                //tweetID is likely not 19 characters long therefore it is not a tweetID so remove the preview
                setQuoteTweetArray((prevState) => {
                  const newArray = [...prevState];
                  newArray[i] = null;
                  return newArray;
                });
                var quoteJoined = quoteIndexes.filter((e) => e !== i);
                setQuoteIndexes(quoteJoined);
              }
            } else {
              //this exists in quoteTweetArray
              //get tweet from cachedtweets
              var cachedTweet = cachedTweets[tweetID];

              if (cachedTweet) {
                //add tweet to quoteTweetArray
                setQuoteTweetArray((prevState) => {
                  const newArray = [...prevState];
                  newArray[i] = tweetID;
                  return newArray;
                });

                //we dont want to remove the link from the raw tweet cause we need to send it to twitter

                tweet = tweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}\n`,
                  '',
                );
                rawTweet = rawTweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}\n`,
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                );

                tweet = tweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                  '',
                );
                rawTweet = rawTweet.replace(
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                  `https://twitter.com/${userHanlde}/status/${tweetID}`,
                );
              } else {
                //broken tweet link
                //remove tweet preview from quoteTweetArray
                setQuoteTweetArray((prevState) => {
                  const newArray = [...prevState];
                  newArray[i] = null;
                  return newArray;
                });
                var quoteJoined = quoteIndexes.filter((e) => e !== i);
                setQuoteIndexes(quoteJoined);
              }
            }
          } else {
            if (tweetID.length === 19 && twitterSecret && twitterToken) {
              getQuoteTweet(tweetID, i);
            }
          }

          var quoteJoined = arrayUnique(quoteIndexes.concat(parseInt(i)));
          setQuoteIndexes(quoteJoined);

          var tweetElement = twitter.default.autoLink(tweet);

          //if a quote tweet exists - remove all link previews
          //remove all link previrews

          setLinkPreviews((prevState) => {
            const newArray = [...prevState];
            newArray[i] = null;
            return newArray;
          });
          var previewsJoined = previewIndexes.filter((e) => e !== i);
          setQuoteIndexes(previewsJoined);

          array[i] = tweetElement;
          rawArray[i] = rawTweet;
        } else {
          //check if there is a reguler link in the tweet
          if (
            (tweet.includes('https://') || tweet.includes('http://')) &&
            !tweet.includes('twitter.com')
          ) {
            //get the link once it has a space at the end

            var regexp =
              /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;

            var result;

            var results = [];

            while ((result = regexp.exec(tweet)) !== null) {
              results.push(result);
            }

            //get last result
            //really should not be getting the link preview on every change. only if the link changes - use the cache system - doing this now!
            if (results.length > 0) {
              var lastResult = results[results.length - 1];
              var lastURL = lastResult[0];

              if (linkPreviews.length > 0) {
                //check if id exists in cache
                var exists = cachedPreviews[lastURL] !== undefined;

                if (exists === false) {
                  getLinkData(lastURL, i);
                } else {
                  var cachedPreview = cachedPreviews[lastURL];

                  if (cachedPreview) {
                    setLinkPreviews((prevState) => {
                      const newArray = [...prevState];
                      newArray[i] = lastURL;
                      return newArray;
                    });
                  }
                }
              } else {
                getLinkData(lastURL, i);
              }

              var previewsJoined = arrayUnique(
                previewIndexes.concat(parseInt(i)),
              );
              setPreviewIndexes(previewsJoined);
            }
          } else {
            //remove all link previrews
            setLinkPreviews((prevState) => {
              const newArray = [...prevState];
              newArray[i] = null;
              return newArray;
            });
            var previewsJoined = previewIndexes.filter((e) => e !== i);
            setQuoteIndexes(previewsJoined);
          }

          //not a tweet link
          setQuoteTweetArray((prevState) => {
            const newArray = [...prevState];
            newArray[i] = null;
            return newArray;
          });
          var quoteJoined = quoteIndexes.filter((e) => e !== i);
          setQuoteIndexes(quoteJoined);

          var tweetElement = twitter.default.autoLink(tweet);
          array[i] = tweetElement;
          rawArray[i] = rawTweet;
        }

        var regexpAt = /@/g;
        var matchAt = regexpAt.exec(tweet);

        while (matchAt != null) {
          array[i] = array[i].replaceAll(
            matchAt[0],
            `<span class='text-blue-400'>${matchAt[0]}</span>`,
          );
          if (b !== null) {
            // document.getElementById(b).innerHTML = array[i]
            matchAt = regexpAt.exec(tweet);
          }
        }
      });

      let trimedArr = array.map((str) => str.trim());
      let rawTrimedArr = rawArray.map((str) => str.trim());

      //compare tweet array with trimmed array to get the index where the tweet is different
      var diff = [];
      for (var i = 0; i < tweetArray.length; i++) {
        if (tweetArray[i] !== trimedArr[i]) {
          diff.push(i);
        }
      }

      //if there is a difference - run handleThreadPreview(`tweet-preview-${i}`)
      if (diff.length > 0) {
        setActiveTweet(`tweet-preview-${diff[0]}`);
      }

      setTweetArrayLength(trimedArr.length);
      setTweetArray(trimedArr);
      setRawTweetArray(rawTrimedArr);
    }
  }

  function arrayUnique(array) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }

    return a;
  }

  const getImageFromDB = (imageName, isSet = false) => {
    try {
      if (userID && imageName) {
        var storageRef = firebase.storage().ref();
        var imgRef = storageRef
          .child(userID)
          .child(activeTypeshareID)
          .child(`${imageName}`);

        imgRef.getDownloadURL().then(onResolve, onReject);

        function onResolve(url) {
          // This can be downloaded directly:
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          xhr.onload = (event) => {
            var blob = xhr.response;
            var reader = new FileReader();
            inEditor &&
              isSet &&
              editor
                .chain()
                .focus()
                .setImage({ src: url, id: imageName })
                .run();
            reader.readAsDataURL(blob);
            reader.onloadend = async function () {
              setImageDataArray((prevState) => ({
                ...prevState,
                [imageName]: reader.result,
              }));
            };
          };
          xhr.open('GET', url);
          xhr.send();
        }

        function onReject(error) {
          if (error.code === 'storage/object-not-found') {
          } else {
            var imgRefOriginal = storageRef
              .child(userID)
              .child(activeTypeshareID)
              .child(`${imageName}`);
            imgRefOriginal.getDownloadURL().then((url) => {
              // This can be downloaded directly:
              var xhr = new XMLHttpRequest();
              xhr.responseType = 'blob';
              xhr.onload = (event) => {
                var blob = xhr.response;
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async function () {
                  setImageDataArray((prevState) => ({
                    ...prevState,
                    [imageName]: reader.result,
                  }));

                  /*  var img = document.getElementById(imageElementID);
                                     if (img !== null) {
                                         img.src = reader.result;
                                     } */
                };
              };
              xhr.open('GET', url);
              xhr.send();
            });
          }
        }
      }
    } catch (error) {
      console.log(error);

      alert('Image not found - do not alter the image code');
    }
  };

  async function getQuoteTweet(tweetID, index) {
    try {
      const { data } = await client.post('/api/tweets/get-tweet-by-id', {
        tweetID,
        twitter: { token: twitterToken, secret: twitterSecret },
      });
      if (data.success === true) {
        setCachedTweets((prevState) => ({
          ...prevState,
          [tweetID]: data.meta,
        }));
        setQuoteTweetArray((prevState) => {
          const newArray = [...prevState];
          newArray[index] = tweetID;
          return newArray;
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  function getLengthTweet(i) {
    var b = `tweet-paragraph-${i}`;
    if (document.getElementById(b) !== null) {
      if (rawTweetArray[i] !== undefined) {
        if (rawTweetArray[i].length < 2) {
          return rawTweetArray[i].length;
        } else {
          const twitInfo = twitter.default.parseTweet(rawTweetArray[i]);
          return twitInfo.weightedLength;
        }
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  useEffect(() => {
    if (tweetArray.length > 0) {
      var tweetLengthsTMP = [];

      tweetArray.forEach((tweet, i) => {
        if (rawTweetArray[i] !== undefined) {
          if (rawTweetArray[i].length < 2) {
            tweetLengthsTMP[i] = rawTweetArray[i].length;
          } else {
            const twitInfo = twitter.default.parseTweet(rawTweetArray[i]);
            tweetLengthsTMP[i] = twitInfo.weightedLength;
          }
        } else {
          return 0;
        }
      });

      setTweetLengths(tweetLengthsTMP);
    }
  }, [rawTweetArray, tweetArray]);

  const getCachedTweet = (tweetID) => {
    //get tweet from cachedTweet array
    var tweet = cachedTweets[tweetID];
    return tweet;
  };

  const getCachedPreview = (link) => {
    //get tweet from cachedTweet array
    var link = cachedPreviews[link];
    return link;
  };

  const autoLinkTweet = (tweet) => {
    var tweetElement = twitter.default.autoLink(tweet);

    var regexpAt = /@/g;
    var matchAt = regexpAt.exec(tweet);

    while (matchAt != null) {
      tweetElement = tweetElement.replaceAll(
        matchAt[0],
        `<span class='text-blue-400'>${matchAt[0]}</span>`,
      );
      matchAt = regexpAt.exec(tweet);
    }

    return tweetElement;
  };

  const getDate = (date) => {
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const newDate = new Date(date).toLocaleDateString(undefined, options);
    return newDate;
  };

  return (
    <>
      {tweetArray.map((tweet, i) => (
        <div
          id={`tweet-preview-${i}`}
          className={`relative flex w-full flex-col justify-start ${
            inEditor
              ? 'pt-4 pb-0 sm:px-2 sm:pt-2 sm:pb-5 md:px-5 md:pt-0 md:pb-0'
              : 'p-2'
          }  mb-2 transform overflow-visible transition-all ${
            tweetLengths[i] !== undefined
              ? tweetLengths[i] > 280
                ? 'bg-red-50'
                : null
              : 0
          }`}
        >
          <div
            className={`flex flex-row space-x-2 ${
              inEditor ? (i === 0 ? 'pt-4' : 'pt-2') : null
            }`}
          >
            <div className={`flex flex-col items-center justify-start `}>
              <div
                className={
                  'max-w-10 relative h-10 max-h-10 min-h-[40px] w-10 overflow-hidden object-cover'
                }
              >
                <TwitterImage
                  width={40}
                  height={40}
                  src={twitterPhoto ? twitterPhoto : photoURL}
                  alt={twitterHandle ? twitterHandle : displayName}
                  userID={userID}
                  className={'aspect-w-1 aspect-h-1 rounded-full'}
                />
              </div>

              {i !== tweetArray.length - 1 && (
                <div className={`-mb-4 h-full w-0.5 bg-gray-200 `} />
              )}
            </div>
            <div className={`w-full overflow-hidden`}>
              <div className="flex flex-row flex-nowrap items-center justify-start space-x-1">
                <div className="flex flex-row flex-nowrap items-center justify-center space-x-1 overflow-hidden font-sans text-xs text-gray-500">
                  <p
                    className={`flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-sans text-base font-bold text-gray-900`}
                  >
                    {twitterName ? twitterName : displayName}
                  </p>
                  <p className="flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-thread text-sm font-normal">
                    @{twitterHandle ? twitterHandle : 'todo'}
                  </p>
                </div>
              </div>

              <div className={'w-full overflow-hidden overflow-ellipsis'}>
                <div
                  className={
                    'relative flex w-full flex-col items-start space-y-2 xs:space-y-1'
                  }
                >
                  {tweetArray[i].length === 0 ? (
                    <p
                      id={'tweet-paragraph-0'}
                      className={`w-full resize-none whitespace-pre-wrap border-none border-transparent bg-transparent p-0 font-thread text-base leading-tight  text-gray-500 placeholder-gray-500 focus:outline-none focus:ring-transparent disabled:text-gray-600`}
                    >
                      Your tweet will appear here...
                    </p>
                  ) : (
                    <div
                      id={`tweet-paragraph-${i}`}
                      class={'tweet-text-thread-main'}
                      dangerouslySetInnerHTML={{ __html: tweetArray[i] }}
                    ></div>
                  )}

                  {imageIDArray[i] ? (
                    imageIDArray[i].length > 0 ? (
                      <div
                        className={`grid w-full ${
                          imageIDArray[i].length < 3
                            ? imageIDArray[i].length === 1
                              ? 'grid-cols-1 grid-rows-2'
                              : 'h-[137px] grid-cols-2 grid-rows-1 gap-x-1'
                            : 'h-[190px] grid-cols-2 grid-rows-2 gap-1'
                        } w-full overflow-hidden rounded-lg`}
                      >
                        {imageIDArray[i].map((imageID, index) => (
                          <div
                            className={` overflow-hidden ${
                              imageIDArray[i].length === 1 ? 'h-auto' : 'h-full'
                            } group relative w-full object-cover ${
                              index === 0
                                ? imageIDArray[i].length === 4
                                  ? 'col-span-1 row-span-1'
                                  : 'col-span-1 row-span-2'
                                : index === 1
                                ? 'col-span-1 row-span-1'
                                : index === 2
                                ? 'col-span-1 row-span-1'
                                : ''
                            } `}
                          >
                            <img
                              id={`image-${i}-${index}`}
                              className={` overflow-hidden ${
                                imageIDArray[i].length === 1
                                  ? 'h-auto'
                                  : 'h-full'
                              } group relative w-full object-cover `}
                              src={imageDataArray[imageIDArray[i][index]]}
                            />
                          </div>
                        ))}
                      </div>
                    ) : null
                  ) : null}

                  {linkPreviews[i] ? (
                    <a
                      href={getCachedPreview(linkPreviews[i]).url}
                      target={'_blank'}
                      className="flex w-full cursor-pointer flex-col overflow-hidden rounded-xl border border-gray-200 bg-white antialiased duration-200 hover:bg-gray-50"
                    >
                      <div
                        className={
                          'flex-center flex max-h-40 w-full justify-center bg-white'
                        }
                      >
                        <img
                          className={'h-40 w-auto'}
                          src={getCachedPreview(linkPreviews[i]).image}
                        />
                      </div>
                      <div
                        className={
                          'flex flex-col items-start justify-start space-y-1 p-3 text-sm text-gray-500'
                        }
                      >
                        <div className="flex flex-row items-center justify-start space-x-1">
                          <LinkIcon className="h-3 w-3 " />
                          <p
                            className={`w-32 truncate overflow-ellipsis font-sans text-sm`}
                          >
                            {getCachedPreview(linkPreviews[i]).display_url}
                          </p>
                        </div>
                        <p
                          className={
                            'w-full flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-medium text-gray-900'
                          }
                        >
                          {getCachedPreview(linkPreviews[i]).title}
                        </p>
                        <p>{getCachedPreview(linkPreviews[i]).description}</p>
                      </div>
                    </a>
                  ) : null}

                  {quoteTweetArray[i] ? (
                    <div
                      layout="position"
                      transition={{ duration: 0.2 }}
                      className={'w-full'}
                    >
                      <a
                        href={getCachedTweet(quoteTweetArray[i]).linkToTweet}
                        target={'_blank'}
                        className="flex w-full cursor-pointer flex-col rounded-xl border border-gray-200 bg-white p-3 antialiased duration-200 hover:bg-gray-50"
                      >
                        <div className="flex flex-row flex-nowrap items-center justify-start space-x-1">
                          <img
                            className="h-5 w-5 rounded-full"
                            src={getCachedTweet(quoteTweetArray[i]).user.image}
                          />
                          <div className="flex flex-row flex-nowrap items-center justify-start space-x-1 overflow-hidden font-sans text-xs text-gray-500">
                            <p
                              className={`flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-sans text-sm font-bold text-gray-900`}
                            >
                              {getCachedTweet(quoteTweetArray[i]).user.name}
                            </p>
                            <p className="flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-thread">
                              @{getCachedTweet(quoteTweetArray[i]).user.handle}
                            </p>
                          </div>
                          <div className="flex flex-row items-center justify-start space-x-1">
                            <div className="h-0.5 w-0.5 rounded-full bg-gray-300" />
                            <p className="flex-nowrap overflow-hidden overflow-ellipsis whitespace-nowrap font-thread text-xs text-gray-500">
                              {getDate(getCachedTweet(quoteTweetArray[i]).date)}
                            </p>
                          </div>
                        </div>

                        <div
                          dangerouslySetInnerHTML={{
                            __html: autoLinkTweet(
                              getCachedTweet(quoteTweetArray[i]).text,
                            ),
                          }}
                          class={'tweet-text-thread-main mt-2'}
                        ></div>

                        {getCachedTweet(quoteTweetArray[i]).media[0].type ===
                        'photo' ? (
                          <img
                            className={'mt-2 w-full rounded-lg'}
                            src={
                              getCachedTweet(quoteTweetArray[i]).media[0].url
                            }
                          />
                        ) : null}
                      </a>
                    </div>
                  ) : null}

                  <div
                    layout="position"
                    transition={{ duration: 0.2 }}
                    className="flex w-full justify-end pb-0.5"
                  >
                    {/*  <p className={`${getLengthTweet(i) > 280 ? "text-red-500" : "text-gray-500"} text-xs`}>Tweet #{i + 1}</p> */}
                    <p
                      className={`${
                        tweetLengths[i] !== undefined
                          ? tweetLengths[i] > 280
                            ? 'font-semibold text-red-500'
                            : 'font-medium text-gray-500'
                          : 'font-medium text-gray-500'
                      } font-sans text-xs`}
                    >
                      {tweetLengths[i] !== undefined ? tweetLengths[i] : 0}/280
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
